import { useContrastQuery } from '../../hooks/use-contrast-query'
import { Query } from '../../hooks/queries'
import {
  RouteCoverageSnapshotQueryArgs,
  RouteCoverageSnapshot,
  getRouteCoverageSnapshots
} from './api/route-coverage-snapshots'
import { QueryClient } from 'react-query'

export function invalidateRouteSnapshotCache({
  client,
  applicationUuid
}: {
  readonly client: QueryClient
  readonly applicationUuid?: string
}) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.invalidateQueries([Query.ROUTE_COVERAGE_SNAPSHOT, applicationUuid])
}

export function useRouteSnapshot(
  organizationUuid: string,
  applicationUuid: string,
  startDate?: Date,
  endDate?: Date
) {
  const now = new Date()
  const oneWeekAgo = new Date()
  oneWeekAgo.setDate(now.getDate() - 7)

  return useContrastQuery<
    RouteCoverageSnapshotQueryArgs,
    RouteCoverageSnapshot
  >(
    [Query.ROUTE_COVERAGE_SNAPSHOT, applicationUuid, { startDate, endDate }],
    getRouteCoverageSnapshots,
    {
      organizationUuid,
      applicationUuid,
      startDate: startDate || oneWeekAgo,
      endDate: endDate || now
    }
  )
}
